// in minutes
export const MINIMUM_EVENT_DURATION = 5;
export const DEFAULT_END_TIME = 30;
// 9 am to 5 pm
export const ALL_DAY_START_TIME = '09:00';
export const ALL_DAY_END_TIME = '17:00';
export const SELECTABLE_EVENT_CONSTRAINT = {
  startTime: '00:00',
  endTime: '24:00',
};
